export default {
  bind: function(el, binding) {
    let themes = binding.value
    el.dataset.topics = themes
    // let faq = new STCFAQ({
    //   container: `#${el.id}`,
    //   platformId: 969,
    //   theme_id: themes,
    //   limit: 5,
    // })
  },
}
